import React from 'react';
import FilterSection from '@client/components/search/FilterSection';
import { ENVIRONMENT_FILTER_CONFIGS, DOCUMENT_TYPE } from '@client/feature/activeSubstance/config/filterConfigs';

const Environment = ({ filters, onFilterChange }) => {
  return (
    <FilterSection
      filterConfigs={ENVIRONMENT_FILTER_CONFIGS}
      filters={filters}
      onFilterChange={onFilterChange}
      document={DOCUMENT_TYPE}
      className="grid grid-cols-1 gap-4 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4"
    />
  );
};

export default Environment;
